const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrivingAbroad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 125,
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 100.35,
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,124.77l-.77-4.25a3.41,3.41,0,0,0-3.34-2.84h-12l-7-16.46a9.81,9.81,0,0,0-8.8-5.72H84.89a9.8,9.8,0,0,0-8.8,5.72l-7,16.46h-12a3.41,3.41,0,0,0-3.34,2.84L53,124.77a3.46,3.46,0,0,0,2.28,3.9l2.72.9a3.47,3.47,0,0,1,1.67,5.33l-2.22,3a3.47,3.47,0,0,0-.66,2l-.17,54.72h0a3.42,3.42,0,0,0,3.41,3.43H72.61a3.42,3.42,0,0,0,3.4-3.44V181.05h98v13.66a3.42,3.42,0,0,0,3.4,3.44H190a3.43,3.43,0,0,0,3.4-3.44L193.19,140a3.47,3.47,0,0,0-.66-2l-2.22-3a3.47,3.47,0,0,1,1.67-5.33l2.72-.9A3.46,3.46,0,0,0,197,124.77Z",
    style: {
      fill: "#282830"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.38,151.64l-.78,4a3.37,3.37,0,0,0,3.26,4l17.11.24a3.37,3.37,0,0,0,3.3-2.47h0a3.37,3.37,0,0,0-2.39-4.16L75.55,149A3.39,3.39,0,0,0,71.38,151.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.62,151.64l.78,4a3.37,3.37,0,0,1-3.26,4l-17.11.24a3.37,3.37,0,0,1-3.3-2.47h0a3.37,3.37,0,0,1,2.39-4.16L174.45,149A3.39,3.39,0,0,1,178.62,151.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.53,106.77a8.53,8.53,0,0,0-7.64-4.73H90.11a8.53,8.53,0,0,0-7.64,4.73L70.54,133.61H179.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,162.88H101.47a1.38,1.38,0,0,0-1.32,1.77l1.94,6.52a1.37,1.37,0,0,0,1.32,1h43.18a1.37,1.37,0,0,0,1.32-1l1.94-6.52a1.38,1.38,0,0,0-1.32-1.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 90.64,
    r: 38.79,
    style: {
      fill: "#282830"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.61 75.46 147.98 72.53 149.35 75.46 152.49 75.87 150.16 78.24 150.71 81.44 147.97 79.91 145.1 81.44 145.65 78.24 143.46 75.87 146.61 75.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.37 89.66 97.51 89.1 98.88 86.18 100.25 89.1 103.39 89.66 101.2 91.89 101.61 95.09 98.88 93.56 96.14 95.09 96.69 91.89 94.37 89.66",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.9 107.07 102.03 105.53 99.29 107.07 99.84 103.87 97.51 101.64 100.66 101.08 102.03 98.3 103.39 101.08 106.53 101.64 104.34 103.87 104.9 107.07",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.36 78.24 104.9 81.44 102.03 79.92 99.29 81.45 99.84 78.25 97.51 75.87 100.66 75.46 102.03 72.53 103.39 75.46 106.53 75.87 104.36 78.24",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.34 116.26 111.6 114.73 108.87 116.26 109.28 113.06 107.09 110.69 110.23 110.27 111.6 107.35 112.97 110.27 116.11 110.69 113.78 113.06 114.34 116.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.79 69.19 114.34 72.4 111.6 70.86 108.87 72.4 109.28 69.19 107.09 66.96 110.23 66.41 111.6 63.62 112.97 66.41 116.11 66.96 113.79 69.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.74 121.83 125 120.3 122.27 121.83 122.68 118.63 120.49 116.4 123.63 115.98 125 113.05 126.37 115.98 129.52 116.4 127.33 118.62 127.74 121.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.33 65.01 127.74 68.21 125 66.69 122.27 68.22 122.68 65.02 120.49 62.79 123.63 62.37 125 59.44 126.37 62.37 129.52 62.79 127.33 65.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.14 116.26 138.41 114.73 135.67 116.26 136.22 113.06 133.89 110.69 137.03 110.27 138.4 107.35 139.77 110.27 142.91 110.69 140.72 113.06 141.14 116.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.73 69.19 141.14 72.4 138.41 70.86 135.67 72.4 136.22 69.19 133.9 66.96 137.04 66.41 138.41 63.62 139.77 66.41 142.92 66.96 140.73 69.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.72 107.07 147.98 105.53 145.11 107.07 145.66 103.87 143.47 101.64 146.61 101.08 147.97 98.3 149.34 101.08 152.49 101.64 150.16 103.87 150.72 107.07",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.86 95.09 151.13 93.56 148.39 95.09 148.8 91.89 146.61 89.67 149.75 89.11 151.12 86.18 152.49 89.11 155.63 89.67 153.3 91.89 153.86 95.09",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrivingAbroad);
export default __webpack_public_path__ + "static/media/drivingAbroad.55749c9e.svg";
export { ForwardRef as ReactComponent };